<template>
	<div class="">
		<el-form :model="form" label-width="50px" size="mini">
			<el-form-item label="Index" v-if="nodeData">
				<el-select v-model="form.index" placeholder="">
					<el-option v-for="item in nodeData.count" :label="item-1" :value="item-1" :key="item"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			node: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				form: {
					index: '',
				},
				count: 0,
				nodeData:null
			}
		},
		created() {

		},
		mounted() {
			this.nodeData = this.node.getData()
			this.form.index = this.nodeData.index
			//console.log(this.nodeData)

		},
		watch: {

		},
		computed: {

		},

		methods: {
			submit() {
				return {
					group:this.nodeData.group,
					index:this.form.index,
					type:'change'
				}
				// this.edge.replaceData(this.form)
				// this.edge.appendLabel(this.form.component)
			}
		},
		components: {

		}
	}
</script>
